module.exports = __webpack_public_path__ + "img/checkout.bbadf767.svg";